import cx from "classnames";
import { FieldProps } from "formik";
import React, { FC, ReactNode } from "react";
import * as form from "../../../styles/shared/form.module.scss";
import { ErrorMessage } from "../ErrorMessage";

import * as styles from "./index.module.scss";

interface Props extends FieldProps {
  id: string;
  label: ReactNode;
  name: string;
  placeholder?: string;
  required?: boolean;
  showErrorMessage?: boolean;
  type?: string;
}

export const InputText: FC<Props> = (props: Props) => {
  const {
    id,
    label,
    placeholder,
    required = false,
    showErrorMessage = true,
    field,
    form: { setFieldValue },
    type = "text",
  } = props;
  const onBlurInput = (e: React.FocusEvent) => {
    field.onBlur(e);
  };
  const onChangeInput = (e: React.SyntheticEvent) => {
    field.onChange(e);
  };
  return (
    <>
      {label ? (
        <label className={form.label} htmlFor={id}>
          {label}
        </label>
      ) : null}
      <div className={form.inputContainer}>
        <input
          type={type}
          id={id ? id : field.name}
          name={field.name}
          className={styles.input}
          placeholder={placeholder}
          required={required}
          onChange={onChangeInput}
          onBlur={onBlurInput}
        />
      </div>
      {showErrorMessage && <ErrorMessage name={field.name} />}
    </>
  );
};
